import { render, staticRenderFns } from "./BatteryStatus.vue?vue&type=template&id=1769f20c&"
import script from "./BatteryStatus.vue?vue&type=script&lang=js&"
export * from "./BatteryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports